import React from 'react'

function Loading({message="Loading..."}) {
  return (
    <div>{message}</div>
  )
}

export default Loading